import { logError } from '@zg-rentals/log-error';

import api from '../utils/api';

const UserActions = {
  addReferral({ code }) {
    return (dispatch) =>
      dispatch(api.users.referrals.add({ code }))
        .then((response) => {
          const { error: errorRMWModel, success } = response;

          if (success) {
            return response.response;
          }

          return Promise.reject(errorRMWModel);
        })
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'UserActions.addReferral',
          });

          return Promise.reject(errorRMWModel);
        });
  },
  trackEvent(params) {
    return (dispatch) =>
      dispatch(api.users.trackEvent(params))
        .then((response = {}) => ({ success: response && response.success }))
        .catch((errorRMWModel) => {
          logError({
            error: errorRMWModel,
            context: 'UserActions.trackEvent',
          });
        });
  },

  setName(params) {
    return (dispatch) =>
      dispatch(api.users.profile.setName(params))
        .then((response = {}) => {
          if (response.success === false) {
            return Promise.reject(response.error);
          }
          return response;
        })
        .catch((err) => Promise.reject(err));
  },
};

export default UserActions;
